import styled from 'styled-components';

export const DivInfo = styled.div`
    display:flex;
    margin:0 0 8px 0;
    font-size:18px;
    >a{
        text-decoration:none;
    }
`;
